import React, { useState } from "react";
import ServiceSlider from "../../commanfile/ServiceSlider";
import ect from "../../Images/electro theraphy image2.jpg";
import Button from "../../commanfile/Button";
import Servicelist from "../../commanfile/Servicelist";
import ps3 from "../../Images/electro therapy image 3.jpg";
import { FaHandHoldingHeart } from "react-icons/fa6";
import comit from "../../Images/electrotherapy image 4.jpg";

const Electrotherapy = () => {
  const symtams1 = [
    "Reduces chronic and acute pain",
    "Improves mood in conditions like depression",
    "Stimulates muscle repair and strengthens weak muscles",
    "Enhances blood circulation and reduces inflammation",
    "Helps relieve stress and anxiety",
  ];
  const symtams = [
    "Supports nerve stimulation and regeneration",
    "Accelerates healing of soft tissue injuries",
    "Improves sleep patterns in some mental health patients",
    "Reduces symptoms of neurological disorders",
    "Non-invasive and drug-free therapy option",
  ];

  const Data = [
    {
      question: "What is electro convulsive therapy? ",
      answer: " Electroconvulsive therapy (ECT) is a medical procedure performed under general anesthesia, where small electrical currents are passed through the brain to trigger a controlled, brief seizure. This treatment can rapidly improve severe mental health symptoms, especially in cases where other therapies have not been effective."
    },
    {
      question: "What causes epilepsy?  ",
      answer: "Epilepsy can be caused by a variety of factors including genetic influences, brain injuries like trauma or stroke, brain tumors, infections such as meningitis or encephalitis, and developmental conditions. Damage before birth or exposure to toxins can also contribute. In many cases, the exact cause is unknown."
    },
    {
      question: "What are the common symptoms of epilepsy?  ",
      answer: " Common symptoms of epilepsy include brief confusion, staring spells, uncontrolled jerking movements of the arms and legs, loss of consciousness or awareness, and sudden emotional changes like fear or anxiety. Symptoms vary depending on the type of seizure and which part of the brain is affected."
    },
    {
      question: "How is epilepsy diagnosed?  ",
      answer: " Epilepsy is diagnosed through a physical exam and medical history review, followed by tests such as an electroencephalogram (EEG) to measure brain electrical activity, MRI or CT scans to detect brain abnormalities, and blood tests. These help confirm the diagnosis and identify seizure types. Sometimes video monitoring and other specialized scans are used for detailed evaluation."
    }, {
      question: "Can epilepsy be cured?  ",
      answer: " Epilepsy cannot be completely cured, but it can often be well controlled with treatment. About 70% of people become seizure-free using anti-seizure medications. For those who don't respond to medications, options include surgery, neurostimulation devices, and dietary therapies. Ongoing research explores advanced treatments like gene therapy and stem cells."
    },
    {
      question: "What treatment options are available for epilepsy?  ",
      answer: "Treatment options for epilepsy include anti-seizure medications, surgery to remove seizure-causing brain areas, neurostimulation devices like vagus nerve stimulation or responsive neurostimulation, and specialized diets like the ketogenic diet. Newer treatments involve deep brain stimulation, minimally invasive surgery, and transcranial magnetic stimulation."
    },
    {
      question: " Do all seizures look the same?  ",
      answer: " No, seizures do not all look the same. They vary widely, from brief staring spells or subtle twitching in one part of the body (focal seizures) to full-body stiffening and jerking movements with loss of consciousness (generalized seizures). Symptoms depend on the brain area affected."
    },
    {
      question: "Is epilepsy a lifelong condition? ",
      answer: " Epilepsy can be lifelong for many people, but with proper treatment, about 60-70% become seizure-free. Some individuals may outgrow epilepsy, especially children. The prognosis varies based on factors like age at onset, type of epilepsy, and treatment response. Early and effective management improves outcomes"
    },
    {
      question: "Can people with epilepsy live normal lives?  ",
      answer: " Yes, people with epilepsy can live normal lives. With proper treatment, lifestyle adjustments, and seizure management, many lead full, active lives. Key strategies include taking medications as prescribed, avoiding seizure triggers, getting enough sleep, managing stress, and maintaining a healthy lifestyle"
    },
     {
      question: "	What should I do if I see someone having a seizure?  ",
      answer: "If you see someone having a seizure, stay calm and keep them safe. Gently place something soft under their head, clear the area of sharp objects, and turn them on their side to keep their airway clear. Do not restrain them or put anything in their mouth. Call for emergency help if the seizure lasts more than 5 minutes, if another seizure follows immediately, or if the person is injured."
    },
     {
      question: "Can epilepsy affect children and older adults differently?  ",
      answer: " Yes, epilepsy can affect children and older adults differently. Children often have epilepsy linked to genetic or developmental causes and may outgrow it. Seizure types and symptoms can vary with age. Older adults are more likely to develop epilepsy due to strokes, tumors, or neurodegenerative diseases, with different management considerations."
    },
      {
      question: "Does epilepsy affect mental health or memory? ",
      answer: " Yes, epilepsy can affect mental health and memory. People with epilepsy have higher risks of anxiety, depression, and other psychiatric disorders due to brain changes and the stress of living with seizures. Memory or concentration difficulties may also occur, either related to seizures or medications."
    },
      {
      question: "Can lifestyle changes help manage epilepsy? ",
      answer: "Yes, lifestyle changes can help manage epilepsy. Important steps include getting enough quality sleep, avoiding seizure triggers like stress, alcohol, and certain drugs, eating a balanced diet, exercising regularly, and managing stress. Keeping a seizure diary and following medication schedules also aid in better control."
    },
      {
      question: "Are there any risks or side effects from epilepsy medications? ",
      answer: "Epilepsy medications can cause side effects such as tiredness, dizziness, stomach upset, blurred vision, and cognitive issues like memory or concentration problems. Some may experience mood changes, allergic reactions, or more serious effects like liver problems or blood disorders. Always discuss risks and benefits with a doctor."
    },
      {
      question: "Is epilepsy hereditary? ",
      answer: " Epilepsy can have a hereditary component. Certain types of epilepsy are linked to genetic mutations that can be inherited from parents. Children with a family history of epilepsy are at higher risk, though not all epilepsy is inherited; many cases result from spontaneous genetic changes or other factors. Genetics play a significant role in some epilepsy forms but do not guarantee the condition"
    },
     {
      question: "	Can stress or lack of sleep trigger seizures? ",
      answer: " Yes, both stress and lack of sleep can trigger seizures in people with epilepsy. Stress releases hormones that affect the brain and can lower the seizure threshold. Lack of sleep increases seizure risk by impacting brain activity and overall health. Managing stress and getting enough rest help reduce seizure frequency."
    },


  ]


  const [isOpen, setisOpen] = useState("null")

  const togglefaqs = (index) => {
    setisOpen(isOpen === index ? null : index)
  }


  return (
    <>
      <div className="max-w-[1456px] mt-2 mx-auto ">
        <div className=" bg-gradient-to-r px-2 from-[#469B8F] pb-8">
          <ServiceSlider 
            classname={"sm:flex  flex-row-reverse"}
            title={"Electrotherapy"}
            content={
              "Electrotherapy is not just about machines and currents—it’s about healing with care."
            }
            maincontent={
              "By using gentle electrical stimulation, it helps reduce pain, improve mobility, and support faster recovery. Whether you are managing an injury, chronic pain, or post-surgery rehabilitation, electrotherapy is a safe and effective way to restore strength and well-being. Healing takes time, but with the right therapy, every session brings you closer to living pain-free and healthier life."}
            buttonname={"Explore Treatment Option "}
             imgs={ect}
          />
        </div>
        <div className="py-16 ">
          <div className="text-center border-b-4">
            <p className="font-roboto text-3xl line-clamp-5 ">
              Here are the key benefits of Electroconvulsive Therapy (ECT)
            </p>

            <div className="lg:flex mx-auto   flex-row-reverse  juscontent-center lg:justify-around py-8 items-center ">
              <div className=" ">
                <img
                  src={ps3}
                  className="border-black px-2  mx-auto rounded-2xl"
                />
              </div>
              <div>
                <div className="md:flex justify-between mx-auto px-3 pl-5 gap-2 ">
                  <div className=" px-2">
                    <Servicelist Symtams={symtams} />
                  </div>
                  <div className="px-2">
                    <Servicelist Symtams={symtams1} />
                  </div>
                </div>
                <div className="mx-auto pt-10 ">
                  <Button
                    className={
                      "text-black hover:text-white font-roboto text-[20px] text-center items-center bg-[#50b1a4] p-1 rounded-full h-[40px] w-[200px]"
                    }
                    btnName={"Get Appointment"}
                    link={"/ContactUs"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mx-auto py-8">
          <div className="sm:flex justify-around flex-row-reverse pt-3 items-center r">
            <div className="sm:w-[50%] w-full ">
              <p className=" flex gap-2 font-roboto text-3xl uppercase text-[#469B8F]">
                <FaHandHoldingHeart />
              Your Journey, Our Purpose
              </p>

              <p className=" mx-auto text-justify text-lg py-3 px-5">
                At Psynexa, we offer Electroconvulsive Therapy (ECT) as a safe
                and effective treatment for severe mental health conditions such
                as depression, bipolar disorder, and schizophrenia.
              </p>
              <p className=" mx-auto text-justify text-lg py-2 px-5">
                ECT involves delivering a brief electrical current to the brain
                under general anesthesia, creating a controlled seizure that
                resets abnormal brain activity. It is especially beneficial for
                patients who do not respond to medications or other therapies
                and is performed in a medically supervised setting.
              </p>
              <p className=" mx-auto text-justify text-lg py-2 px-5">
                Our expert team ensures comfort and safety using the latest equipment and strict clinical protocols. We provide ongoing support to patients and families while working to reduce stigma and raise awareness about ECT’s powerful impact on mental health recovery.
              </p>
            </div>
            <div className="">
              <img
                src={comit}
                className="w-[400px] h-[400px] border-double border-t-[30px] border-spacing-44 border-[#45b3a4] border-b-[30px] border-r-[30px] border-l-[30px] rounded-full "
                alt=""
              />
            </div>
          </div>
        </div>

         <div className="mx-auto md:pl-[40px] md:pr-[40px] p-2 pt-10">
          <div className="mx-auto">
            <p className="text-2xl font-bold text-center font-roboto">FAQs</p>
          </div>
          <div className="space-y-4 mt-4">
            {Data.map((faq, index) => (
              <div key={index} className="border border-gray-200 w-[100%] mx-auto rounded-lg">
                <button
                  onClick={() => togglefaqs(index)}
                  className="w-full text-left px-4 py-3 flex justify-between items-center focus:outline-none"
                >
                  <span className="font-medium font-roboto">{faq.question}</span>
                  <span>{isOpen === index ? '-' : '+'}</span>
                </button>
                {isOpen === index && (
                  <div className="px-4 py-2 font-roboto text-justify text-gray-600">{faq.answer}</div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Electrotherapy;
